// extracted by mini-css-extract-plugin
export var cartIcon = "_nf-0";
export var cartIconContainer = "_nf-1";